






WP = require "scripts/wordpress"
module.exports =
	components:
		singleTemplate: require "./singleTemplate"
		spinner: require "components/common/spinner"
	data: ->
		single: { loading: false, content:null }
	computed:
		pageName: -> return this.$route.name
		id: -> this.$route.params.id
		postType: -> return WP.getArchivePostType(this.pageName.replace("en_",""))
		endPoint: -> return WP.getEndPoint(this.postType, this.id)
	methods:
		getPosts: -> WP.getContent(this.endPoint, this.single)
	mounted: ->
		this.getPosts()
	updated: ->
		this.getPosts()



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/single/single.vue